import useWindowWidth from '../../hooks/useWindowWidth';
import { HeaderDesktop } from './_Desktop';
import { HeaderMobile } from './_Mobile';

export function Header(props) {
    const vw = useWindowWidth();

    if (vw < 576) {
        return (
            <HeaderMobile
                {...props}
                logoDimensions={{
                    width: 104,
                    height: 64,
                    float: 'none',
                }}
            />
        );
    }
    return <HeaderDesktop {...props} />;
}
